import React from 'react';
import Conditional from '../../common/conditional';

import { formatTime } from '../../../utils/utilities';
import { InspectedItemDetails } from '../../../utils/models';

import classNames from './style.module.scss';

interface InspectedItemProps {
	data: InspectedItemDetails[];
}

const InspectedItem: React.FC<InspectedItemProps> = (props) => {
	return (
		<Conditional isVisible={props.data.length > 0}>
			{props.data.map((item, index: number) => (
				<ul key={item.id} className={classNames['list-option']}>
					<li key={index} className={classNames['list-option-item']}>
						<div className={classNames['list-option-item-block']}>
							<h4>Inspected Item Number:</h4>
							<p>{item.id}</p>
						</div>
						
						<div className="divider my-2"></div>

						<div className={classNames['list-option-item-block']}>
							<h4>Inspected By:</h4>
							<p>{item.name}</p>
						</div>

						<div className="divider my-2"></div>
						
						<div className={classNames['list-option-item-block']}>
							<h4>Date Published:</h4>
							<p>{item.date ? formatTime(item.date) : 'In progress'}</p>
						</div>
					</li>
				</ul>
			))}
		</Conditional>
	);
};

export default InspectedItem;
